import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Breadcrumb extends Component {
    render() {
        return (
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb pl-0" style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                    <div style={{display:'flex'}}>
                        <li className="breadcrumb-item"><Link to="#"><i className="material-icons">home</i> Home</Link></li>
                        <li className="breadcrumb-item"><Link to="#">Menu</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Menu Grid</li>
                    </div>
                    <li className="breadcrumb-item">
                        <a href="#" onClick={(e) => { e.preventDefault(); window.location.href='https://api.novetheitaliankitchen.in/index.php/Api/downloadMenuCsv'; }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24" style={{marginRight:'5px'}}><path d="M12 16l-5-5h3V4h4v7h3l-5 5zm-7 2h14v2H5v-2z"/></svg>
                            Download CSV
                        </a>
                    </li>
                </ol>
            </nav>
        );
    }
}

export default Breadcrumb;